import React from "react";
import Table from "react-bootstrap/Table";
import "./table-generic.css";

const TableGeneric = ({
	columns = [],
	data = [],
	rowKey = "id"
}) => {
	if (!Array.isArray(data) || data.length === 0) {
		return null;
	}

	return (
		<div className="table-generic__container">
			<Table className="table-generic">
				<thead>
					<tr>
						{columns.map(column => (
							<th
								key={column.key}
								style={{ width: column.width }}
							>
								{column.label}
							</th>
						))}
					</tr>
				</thead>

				<tbody>
					{data.map((row, rowIndex) => (
						<tr key={row[rowKey] ?? rowIndex}>
							{columns.map(column => (
								<td key={column.key}>
									{column.render
										? column.render(row)
										: row[column.key]
									}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</Table>
		</div>
	);
};

export default TableGeneric;